import React, { useEffect, useState } from 'react';
import '../CSS/Global.css'; // Ensure your CSS file path is correct
import { useNavigate } from 'react-router-dom';
import productadd from "../Images/productadd.png"
import { Spinner, useToast } from '@chakra-ui/react';

const AddProduct = () => {
  const [productName, setProductName] = useState('');
  const [mrp, setMrp] = useState('');
  const [sellingPrice, setSellingPrice] = useState('');
  const [shortDescription, setShortDescription] = useState('');
  const [image, setImage] = useState()
  const login = JSON.parse(localStorage.getItem("login")) || ""
  let navigate = useNavigate()
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState('');
  const [quantity, setSelectedQuantity] = useState('');
  const toast = useToast()
  const [load, setLoad] = useState(true);
  const [showAdditional, setShowAdditional] = useState(false);
  const [shiftHour, setShiftHour] = useState('');


  const handleImageUpload = (event) => {
    const file = event.target.files[0]; // Get the first file from input
    setImage(file); // Store the selected image in state
  };

  // Add form submission logic here

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoad(false);
    // Create FormData object to send image along with other data
    const formData = new FormData();
    formData.append('product_image', image);
    formData.append('product_name', productName);
    formData.append('mrp_price', mrp);
    formData.append('sell_price', sellingPrice);
    formData.append('quantity', quantity);
    formData.append('unit', selectedUnit);
    formData.append('description', shortDescription);
    formData.append('user_id', login.permanent_ID);
    formData.append('user_name', login.name);
    formData.append('shift_hour', shiftHour);


    try {
      // Replace with your backend API URL
      const response = await fetch(`https://filmlocation.100billion.in/product/add-product/${login.permanent_ID}`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();
      console.log('Image uploaded:', result);
      if (response.ok) {
        toast({
          description: `Product added successfully`,
          status: 'success',
          duration: 5000,
          position: 'top-center',
          isClosable: true,
        });
        navigate(-1)
        setLoad(true)
      }
    } catch (error) {
      console.log('Error uploading image:', error);
      setLoad(true)
    }
    // console.log({
    //   productName,
    //   mrp,
    //   sellingPrice,
    //   shortDescription,
    // });
  };

  const [category, setCategory] = useState();

  const fetchDataUser = async () => {
    try {
      const response = await fetch(`https://filmlocation.100billion.in/store/getstorelist/mystore/${login.permanent_ID}`);
      const store = await response.json();
      console.log(store);
      setCategory(store.category)
    } catch (error) {
      console.log(error);
    }
  }

  const fetchCategory = async () => {
    try {
      const response = await fetch(`https://filmlocation.100billion.in/category/singlecategory/${category}`);
      const res = await response.json();
      console.log(res);

      // Parse the units field
      if (res.units) {
        const parsedUnits = JSON.parse(res.units);
        console.log('Parsed Units:', parsedUnits);
        setUnits(parsedUnits);
      } else {
        console.log('Units field is not available');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (category) {
      fetchCategory();
    }
  }, [category]);


  useEffect(() => {
    fetchDataUser();
    // fetchCategory();
  }, [])

  const hours = Array.from({ length: 24 }, (_, i) => {
    const value = i + 1;
    return {
      value: value,
      label: value.toString().padStart(2, '0') + ' hrs'
    };
  });

  console.log(selectedUnit);


  return (
    <div className="product-container">
      <div className="product-image-column">
        <img
          src={productadd}
          alt="Product"
          className="product-image"
        />
      </div>
      <div className="product-form-column">
        <h2>List Your Product/Skills/Service</h2>
        <form onSubmit={handleSubmit}>
          <div className="product-form-group">
            <label>Title:</label>
            <input
              type="text"
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
              placeholder="Enter title"
              required
            />
          </div>
          <div className="product-form-group">
            <label>Upload Image (Optional):</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}

            />
          </div>
          <div className="product-form-group">
            <label>Short Description (max 50 chars):</label>
            <input
              type="text"
              value={shortDescription}
              onChange={(e) => setShortDescription(e.target.value)}
              maxLength="50"
              placeholder="Enter short description"
              required
            />
          </div>
          <div className="product-form-group">
            <label style={{ fontWeight: "600" }}>Additional Details</label>
            <div
              onClick={() => setShowAdditional(!showAdditional)}
              className="toggle-btn"
              style={{
                width: "60px",
                height: "30px",
                background: showAdditional ? "var(--red)" : "#ccc",
                borderRadius: "20px",
                cursor: "pointer",
                position: "relative",
                transition: "0.3s",
                marginBottom: "10px"
              }}
            >
              <div
                style={{
                  width: "26px",
                  height: "26px",
                  background: "#fff",
                  borderRadius: "50%",
                  position: "absolute",
                  top: "2px",
                  left: showAdditional ? "32px" : "2px",
                  transition: "0.3s"
                }}
              ></div>
            </div>
          </div>

          {showAdditional && (
            <div className="additional-section" style={{
              padding: "15px",
              background: "#fff",
              borderRadius: "10px",
              marginBottom: "15px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
            }}>
              <div className="product-form-group">
                <label>Hourly Shift:</label>
                <select
                  className="bestselecttagforec"
                  value={shiftHour}
                  onChange={(e) => setShiftHour(e.target.value)}
                >
                  <option value="">Select Hours</option>
                  {hours.map((hour) => (
                    <option key={hour.value} value={hour.value}>
                      {hour.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="price-container">

                <div className="product-form-group">
                  <label>Unit:</label>
                  <select
                    className="bestselecttagforec"
                    value={selectedUnit}
                    onChange={(e) => setSelectedUnit(e.target.value)}
                  >
                    <option value="">Select Unit</option>
                    {units.map((unit, index) => (
                      <option key={index} value={unit}>
                        {unit}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="product-form-group">
                  <label>
                    Quantity/Value{" "}
                    {selectedUnit ? `(${selectedUnit})` : ""}
                  </label>

                  <input
                    type="number"
                    value={quantity}
                    onChange={(e) => setSelectedQuantity(e.target.value)}
                    placeholder={selectedUnit ? `Enter Value in ${selectedUnit}` : "Enter Value"}
                  />
                </div>

              </div>

              <div className="price-container">

                <div className="product-form-group">
                  <label>MRP:</label>
                  <input
                    type="number"
                    value={mrp}
                    onChange={(e) => setMrp(e.target.value)}
                    placeholder="Enter MRP"
                  />
                </div>

                <div className="product-form-group">
                  <label>Selling Price:</label>
                  <input
                    type="number"
                    value={sellingPrice}
                    onChange={(e) => setSellingPrice(e.target.value)}
                    placeholder="Enter Selling Price"
                  />
                </div>

              </div>

            </div>
          )}


          {/* <div className="price-container">
            <div className="product-form-group">
              <label>Unit (Optional):</label>
              <select
                className='bestselecttagforec'
                value={selectedUnit}
                onChange={(e) => setSelectedUnit(e.target.value)}
                
              >
                <option value="">Select Unit</option>
                {units.map((unit, index) => (
                  <option key={index} value={unit}>
                    {unit}
                  </option>
                ))}
              </select>
            </div>
            <div className="product-form-group">
              <label>Quantity/Value {selectedUnit === "" ? null : ("(" + selectedUnit + ")")} (Optional):</label>
              <input
                type="quantity"
                value={quantity}
                onChange={(e) => setSelectedQuantity(e.target.value)}
                placeholder={`Enter Value in ${selectedUnit}`}
                
              />
            </div>

          </div>
          
          

         
          <div className="price-container">
            <div className="product-form-group">
              <label>MRP (Optional):</label>
              <input
                type="number"
                value={mrp}
                onChange={(e) => setMrp(e.target.value)}
                placeholder="Enter MRP"
                
              />
            </div>
            <div className="product-form-group">
              <label>Selling Price (Optional):</label>
              <input
                type="number"
                value={sellingPrice}
                onChange={(e) => setSellingPrice(e.target.value)}
                placeholder="Enter Selling Price"
                
              />
            </div>
          </div> */}
          {
            load ? <button type="submit" className="product-submit-button">Add Product</button> :
              <button className="product-submit-button"><Spinner /></button>
          }
        </form>
      </div>
    </div>
  );
};

export default AddProduct;
